(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-design-product"]) return;
  try {
    

function initACPhotoProducts(scope = document) {
  scope.querySelectorAll('[data-ac-photo-product]').forEach(root => {
    if (root.dataset.photoReady) return;
    root.dataset.photoReady = 'true';
    const data = JSON.parse(root.querySelector('[data-ac-data]').textContent);
    const photos = JSON.parse(root.querySelector('[data-ac-photos]').textContent);
    const currency = JSON.parse(root.querySelector('[data-ac-currency]').textContent) || 'AUD';
    const selectors = [...root.querySelectorAll('[data-ac-option]')];
    const button = root.querySelector('[data-ac-buy]');
    const stage = root.querySelector('[data-ac-stage]');
    const base = root.querySelector('.ac-base-photo');
    const caption = root.querySelector('[data-ac-photo-caption]');
    let photoKey, request = 0;
    function showPhoto(variant) {
      const key = variant ? JSON.stringify(variant.options.slice(0, 2)) : '';
      if (key === photoKey) return;
      photoKey = key;
      const token = ++request;
      const entry = variant && photos.find(p => p.garment === variant.options[0] && p.colour === variant.options[1]);
      base.onload = null;
      base.onerror = null;
      if (!entry) {
        stage.dataset.mode = 'artwork';
        base.hidden = true;
        base.removeAttribute('srcset');
        base.removeAttribute('src');
        caption.textContent = root.dataset.photoMissing;
        return;
      }
      stage.dataset.mode = 'loading';
      caption.textContent = root.dataset.photoLoading;
      base.hidden = true;
      stage.style.setProperty('--photo-ratio', entry.width / entry.height);
      ['x','y','w','h'].forEach(axis => stage.style.setProperty('--print-' + axis, entry[axis] + '%'));
      const loaded = () => {
        if (token !== request || base.getAttribute('src') !== entry.url) return;
        stage.dataset.mode = 'photo';
        base.hidden = false;
        caption.textContent = root.dataset.photoNote;
      };
      base.onload = loaded;
      base.onerror = () => {
        if (token !== request) return;
        stage.dataset.mode = 'artwork';
        base.hidden = true;
        caption.textContent = root.dataset.photoMissing;
      };
      base.alt = entry.alt;
      base.width = entry.width;
      base.height = entry.height;
      base.removeAttribute('srcset');
      base.src = entry.url;
      if (base.complete && base.naturalWidth > 0) loaded();
    }
    function update() {
      let candidates = data.variants;
      selectors.forEach(select => {
        const index = Number(select.dataset.acOption);
        const allowed = [...new Set(candidates.map(v => v.options[index]))];
        for (const option of select.options) { option.disabled = !allowed.includes(option.value); option.hidden = option.disabled; }
        if (!allowed.includes(select.value)) select.value = allowed[0] || '';
        candidates = candidates.filter(v => v.options[index] === select.value);
      });
      const variant = candidates[0];
      root.querySelector('[data-ac-variant]').value = variant ? variant.id : '';
      button.disabled = !variant || !variant.available;
      button.textContent = button.disabled ? root.dataset.unavailableLabel : root.dataset.addLabel;
      showPhoto(variant);
      if (variant) {
        root.querySelector('[data-ac-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency}).format(variant.price / 100);
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    selectors.forEach(select => select.addEventListener('change', update));
    update();
  });
}
initACPhotoProducts();
document.addEventListener('shopify:section:load', event => initACPhotoProducts(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
